import React from 'react';
import classNames from 'classnames';
import { useRouteMatch } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import { SetupForm } from './SetupForm/SetupForm';

import css from './FbConversionsApi.module.css';

type Props = {
  className?: string;
};

export const FBConversionsApi = ({ className }: Props) => {
  const match = useRouteMatch<{ id?: string; chatbotId: string }>();
  const containerClassName = classNames(className, css.container);

  return (
    <div className={containerClassName}>
      <Switch>
        <Route path={`${match.path}/setup/:step?`} component={SetupForm} />

        <Redirect to={`${match.url}/setup`} />
      </Switch>
    </div>
  );
};
